<div class="grey-text" translate>
  PHONE.AGENT_ONLINE.SIMULTANEOUS_DESCRIPTION
</div>
